import { Injectable } from '@angular/core';
import { SubmitCashbackSuccess } from '@features/cashback/store/actions/cashback.actions';
import { CheckoutOrderSuccess } from '@features/order-checkout/actions/order-checkout.actions';
import * as transferConnectV2Actions from '@features/transfer-connect-v2/store/actions';
import { UserInit } from '@features/user-init/user-init.actions';
import * as userPreferenceActions from '@features/user-preference/store/actions/user-preference.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PromocodeBannerApiService } from '../services/promocode-banner-api.service';
import { PromocodeBanner } from '../types';
import {
  LoadPromocodeBanners,
  LoadPromocodeBannersFail,
  LoadPromocodeBannersSucces,
} from './promocode-banner.actions';

@Injectable()
export class PromocodeBannerEffects {
  constructor(
    private actions$: Actions,
    private promocodeBannerApiService: PromocodeBannerApiService,
  ) {}

  initiateLoadBannersOnUserInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        UserInit,
        CheckoutOrderSuccess,
        SubmitCashbackSuccess,
        transferConnectV2Actions.CheckoutActionTypes
          .SUBMIT_POINTS_TRANSFER_SUCCESS,
        userPreferenceActions.UserPreferenceActionTypes
          .UPDATE_POINTS_ACCOUNT_ID_SUCCESS,
      ),
      map(() => {
        return LoadPromocodeBanners();
      }),
    ),
  );

  loadPromocodeBanners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadPromocodeBanners),
      switchMap(() => {
        return this.promocodeBannerApiService.getPromocodeBanners().pipe(
          map((promocodeBanners: PromocodeBanner[]) => {
            return LoadPromocodeBannersSucces({
              promocodeBanners,
            });
          }),
          catchError((error: HttpError) => of(LoadPromocodeBannersFail(error))),
        );
      }),
    ),
  );
}
